.root {
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.fullHeight {
  min-height: 100vh;
}
